import Api from "../api";

const uri = "/api/ed/capacitacion/presencial";

export const getParticipantesByCapacitacion = (idCapacitacion) => {
  return Api.getInstance()
    .executeGetQuery(`${uri}/${idCapacitacion}/participantes`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const updateParticipante = (participanteData) => {
  return Api.getInstance()
    .executeUpdateQuery(`${uri}/participante`, participanteData)
    .then((resp) => resp)
    .catch((error) => console.log(error));
};

export const createParticipantesBatch = (formData) => {
  return Api.getInstance()
    .executeMultipart(`${uri}/participantes`, formData)
    .then((resp) => resp)
    .catch((error) => console.log(error));
};
